const bioContents = {
    gceo: {
        bioName: "الدكتور محمد فاروق",
        bioPos: "نائب رئيس مجلس الإدارة",
        bioDesc: `<p>
        يشغل الدكتور محمد فاروق محمد عبد المجيد عبد الخالق عضوية مجلس إدارة مجموعة أديس ويتولى منصب الرئيس التنفيذي للمجموعة منذ عام 2012م، وخلال هذه الفترة قاد توسع الشركة في أسواق وقطاعات جديدة، ومسيرة تحولها إلى شركة رائدة في قطاع الحفر تتّخذ من مدينة الخُبر في المملكة مقرّاً لها منذ عام 2022م.

      </p>
     <p>
      وعمل قبل انضمامه إلى مجموعة أديس كنائب أول لرئيس العمليات والتسليم الدولي في شركة “إنفينسيس” لإدارة العمليات في تكساس. كما عمل سابقاً في شركة “إنفينسيس” كمدير لمراكز التميز الهندسي في مصر، والهند، والصين، والأرجنتين، وقبل ذلك، شغل منصب المدير العام لشركة “إنفينسيس” للهندسة والخدمات في مصر. وبدأ الدكتور محمد فاروق حياته المهنية عام 1991 كمهندس مشروع في شركة تكنولوجيا التحكم والقياس “كونيسيس” في مصر.

     </p>
      <p>
        وبعد حصوله على شهادة الدكتوراه في هندسة الأنظمة والتحكم من جامعة كيس ويسترن ريزيرف أوهايو، الولايات المتحدة الأمريكية، أصبح الدكتور محمد فاروق أستاذاً مساعداً في كلية الهندسة الكهربائية بجامعة القاهرة. كما تولّى عدّة مناصب أخرى سابقة، كعضوية مجلس إدارة شركة “شنايدر إلكتريك” لأنظمة العمليات، بينما لا يزال يشغل منصب رئيس مجلس إدارة غير تنفيذي في شركة “شنايدر إلكتريك” للهندسة والخدمات في مصر، وعضوية مجلس إدارة شركة العاشر من رمضان للصناعات الدوائية والمستحضرات التشخيصية “راميدا”.
      </p>`
    },
    cfo: {
        bioName: "حسين بدوي",
        bioPos: "الرئيس التنفيذي للشؤون المالية",
        bioDesc: `
        <p>
        انضم حسين محمد عبد السلام حسن بدوي إلى أديس في عام 2016م، وتم تعيينه في
        منصب الرئيس التنفيذي للشؤون المالية في ديسمبر 2021م. وقبل تعيينه في هذا
        المنصب، شغل السيد حسين عدة مناصب هامة كمدير للشؤون المالية المؤسسية
        وعلاقات المستثمرين. تتجاوز خبرة السيد حسين أكثر من 14 عاماً كان له
        خلالها دور هام في تعزيز النمو المستدام وترسيخ الاستقرار المالي لشركة
        أديس من خلال الاستثمارات الاستراتيجية المدعومة بهيكل رأسمالي قوي.
      </p>
      <p>
        كما يدير السيد حسين جميع الأقسام المعنية بالشؤون المالية ويقود قسمي
        التخطيط الاستراتيجي ودعم اتخاذ القرارات بما يدعم جهود المجموعة نحو تطبيق
        استراتيجيات سوق فعالة والاستفادة من التحليلات. وقبل انضمامه إلى أديس،
        شغل السيد حسين منصب مدير علاقات أول في مجموعة الخدمات المصرفية للشركات
        والاستثمار، المصرف العربي الدولي متعدد الأطراف.
      </p>

      <p>
        يحمل السيد حسين شهادة البكالوريوس في إدارة الأعمال الدولية من أكاديمية
        السادات للعلوم الإدارية، مصر، بالتعاون مع جامعة نيو برونزويك، كندا.
        ويحمل شهادة احترافية في إدارة مخاطر الائتمان والمخاطر من كلية إدارة
        الأعمال بالجامعة الأمريكية بالقاهرة.
      </p>`
    },
    gcla: {
        bioName: "مرقس اقلاديوس",
        bioPos: "المستشار العام للشؤون القانونية للمجموعة",
        bioDesc: `<p>
        انضم مرقس وليم فلتاؤوس اقلاديوس إلى مجموعة أديس في يوليو 2015 ويشغل منصب المستشار العام للشئون القانونية وأمين سر الشركة. قبل انضمامه إلى المجموعة، كان السيد وليم يشغل منصب رئيس الشؤون القانونية في شركة أوراسكوم للاتصالات والإعلام والتكنولوجيا القابضة ومحامي رئيسي لشركة موبينيل (أورانج الآن). يجمع السيد وليم بما يقرب من 20 عامًا من الخبرة في قطاعات أعمال متنوعة بما في ذلك الاتصالات والإعلام والتكنولوجيا والتطوير العقاري وقظاع القانون البحري وقطاع أعمال النفط والغاز.
        </p>
        <p>
        تتنوع الخبرة القانونية للسيد وليم بين أسواق رأس المال وإعادة الهيكلة والاستحواذات وتمويل المشاريع. ويقدر السيد مرقس في مجال عمله بصفته المستشار العام للشئون القانونية للمجموعة فيما يتعلق بالتوسع الهائل للمجموعة. على مدى السنوات الثماني الماضية وحتى الآن، قاد الفريق القانوني لمجموعة أديس في العديد من المشاريع بما في ذلك الإدراج والشطب من بورصة لندن، ودعم عمليات المجموعة عبر مختلف البلدان، وقام بالعديد من عمليات إعادة هيكلة المجموعة والحصول على قروض مشتركة.
        </p>
        <p>
        يحمل مرقس شهادة البكالوريوس في القانون ودرجة الماجستير في المعاملات التجارية الدولية والخدمات اللوجستية من الأكاديمية العربية للعلوم والتكنولوجيا.
        </p>`
    },
    vcades: {
        bioName: "منتصر سامي",
        bioPos: "نائب الرئيس في المملكة العربية السعودية",
        bioDesc: `<p>
        يشغل منتصر محمد سامي عبد الرحمن محمد نجيب منصب نائب الرئيس والمدير العام
        في شركة أديس القابضة في المملكة العربية السعودية، ويشكّل أحد أبرز أفراد
        فريق إدارة الشركة. بدأ السيد منتصر مسيرته المهنية في قسم تكسير وتنشيط
        الآبار في شركة شلمبرجير، وتولى بعد ذلك العديد من المناصب القيادية في
        فروع الشركة في أوروبا والشرق الأوسط وروسيا والولايات المتحدة.
      </p>
      <p>
        شغل السيد منتصر قبل مغادرة شركة شلمبرجير المحدودة منصب نائب الرئيس
        لخدمات الإنتاج المتكاملة العالمية خارج المملكة المتحدة، كما عمل في عدة
        مناصب، بما في ذلك نائب الرئيس لخدمات الآبار في منطقة الشرق الأوسط وآسيا
        ونائب الرئيس لقسم سلامة الآبار في مناطق المياه العميقة.
      </p>
      <p>
        يحمل السيد منتصر شهادة البكالوريوس في الهندسة الميكانيكية من الجامعة
        الأمريكية في القاهرة.
      </p>`
    },
    sherm: {
        bioName: "مهدي حمال",
        bioPos: "المدير العالمى للسلامة والصحة والبيئة وإدارة المخاطر",
        bioDesc: `<p>
        انضم مهدي حمال إلى شركة أديس القابضة في مارس 2022م بمنصب المدير العالمي
        للسلامة والصحة والبيئة وإدارة المخاطر، حيث يؤدي دوراً مهماً في إرساء
        أعلى معايير الجودة والصحة والسلامة والبيئة وإدارة المخاطر في فروع الشركة
        حول العالم.
      </p>
      <p>
        يمتلك السيد مهدي مسيرة مهنية طويلة تمتد لأكثر من 20 عاماً في عدة أسواق،
        بما فيها أوروبا والشرق الأوسط وأفريقيا، كما شغل العديد من المناصب المهمة
        في مجالي سلاسل التوريد والسلامة والصحة والبيئة وإدارة المخاطر في شركات
        كبرى في قطاع النفط والغاز، مثل ويسترن جيكو وشلمبرجير.
      </p>
      <p>
        وقاد السيد مهدي العديد من المبادرات الاستراتيجية خلال مسيرته المهنية
        والتي أدت إلى إحداث تحسين ملحوظ في ممارسات السلامة والصحة والبيئة وإدارة
        المخاطر. يحمل السيد مهدي إجازة في الهندسة الجيوفيزيائية والبتروفيزياء من
        جامعة هواري بومدين للعلوم والتكنولوجيا وشهادة الماجستير في هندسة البترول
        من جامعة هيريوت وات.
      </p>`
    },
    ccso: {
        bioName: "أحمد عبد الهادي",
        bioPos: "الرئيس التنفيذي للقطاعات التجارية والاستراتيجية",
        bioDesc: ` <p>
        انضم أحمد محمد عبد الهادي عثمان إلى مجموعة أديس في مايو 2022م ليتولى
        منصب الرئيس التنفيذي للقطاعات التجارية والاستراتيجية، ليكون مسؤولاً عن
        تحديد وتنفيذ أهداف واستراتيجيات أعمال المجموعة، وقيادة الجهود التسويقية
        الشاملة لأسطول المجموعة. كما يتولى السيد أحمد في منصبه الحالي إدارة
        العمليات التجارية والاستراتيجية. وقبل انضمامه إلى أديس، أمضى السيد أحمد
        أكثر من عشر سنوات بالعمل مع شركة "شلف للحفر" في دبي، الإمارات العربية
        المتحدة مديراً إقليمياً للتسويق في مناطق الشرق الأوسط، وأوروبا، وشمال
        أفريقيا.
      </p>
      <p>
        وبفضل خبرته التي تمتد لأكثر من 20 عاماً، تولّى السيد أحمد العديد من
        المناصب القيادية والإدارية العليا في مجالات التسويق والعقود، وعمليات
        الحفر، والمشاريع، وإدارة الأصول، وإدارة أنظمة الجودة والصحة والسلامة
        والبيئة في عدّة شركات رائدة مثل شركة "جلوبال سانتا في" و"ترانس أوشن".
        وبدأ السيد أحمد مسيرته المهنية في قطاع الحفر البحري بعمله في شركة "سانتا
        في" عام 2001م.
      </p>
      <p>
        يحمل السيد أحمد شهادة البكالوريوس في الهندسة المدنية من جامعة القاهرة في
        مصر، في اختصاص دراسات إدارة المشاريع.
      </p>`
    },
    vcam: {
        bioName: "محمد سعد",
        bioPos: "نائب رئيس الشركة لإدارة الأصول",
        bioDesc: `<p>
        انضم محمد سعد خليل الصيرة إلى مجموعة أديس في سبتمبر 2015م بمنصب المدير
        الإقليمي لشؤون الصيانة وإدارة الأصول، ويشغل حالياً منصب نائب رئيس الشركة
        لإدارة الأصول منذ أكتوبر 2022م. وحرص الصيرة منذ انضمامه إلى الشركة على
        تطبيق العمليات الهندسية المعتمدة ومتعددة التخصصات، إلى جانب الممارسات
        التقنية واستراتيجيات الصيانة الفعالة، التي تضمن التشغيل الناجح لأصول
        الشركة مع اعتماد أفضل الممارسات وأعلى معايير الجودة في إدارة العمليات
        والأسطول المؤلف من رافعات المنصات البحرية ومنصات الحفر البرية والبارجات
        ووحدات الحفر البحرية المتنقلة ووحدات التخزين والتفريغ العائمة.
      </p>
      <p>
        يمتلك السيد محمد خبرة مهنية طويلة تمتد لأكثر من 13 عاماً، وشغل عدة مناصب
        في شركات كبرى مثل ترانس أوشن المحدودة، حيث بدأ مسيرته المهنية كمشرف
        ميكانيكي في فرع الشركة في مصر، وقاد مسيرة مهنية ناجحة حتى تعيينه بمنصب
        مدير إدارة الأصول في فرع الشركة في مالطا في عام 2015م. يحمل السيد محمد
        شهادة البكالوريوس في هندسة القوى المبكانيكية، بالإضافة إلى العديد من
        الشهادات المتخصصة.
      </p>`
    },
    cpo: {
        bioName: "مانوج برمش",
        bioPos: "الرئيس التنفيذي للموارد البشرية",
        bioDesc: `<p>
        انضم مانوج غانيش برمش إلى مجموعة أديس في يناير 2023م ليشغل منصب الرئيس
        التنفيذي للموارد البشرية ويشرف على عمليات إدارة الموارد البشرية والتعلم.
        يمتلك السيد مانوج خبرة تمتد لأكثر من 25 عاماً في مجالات التخطيط
        الاستراتيجي للموارد البشرية، وبناء القدرات، وتعبئة الموارد على نطاق
        واسع، وإدارة تنمية المنظمات وبرامج تطوير الكفاءات.
      </p>
      <p>
        يمتلك السيد مانوج فهماً معمّقاً وإلماماً بصناعة الغاز والنفط نتيجة عمله
        مع العديد من شركات التنقيب والإنتاج في قطاعي خدمات النفط ومقاولات الحفر.
      </p>
      <p>
        وعمل السيد مانوج في العديد من المواقع في آسيا، والشرق الأوسط وشمال
        أفريقيا، كما تولى العديد من المناصب القيادية في إدارة الموارد البشرية في
        كل من شركتي "رليانس للصناعات المحدودة" العاملة في قطاع استكشاف وإنتاج
        النفط، و"وذرفورد دريلينج انترناشيونال". كما شغل منصباً إدارياً في شركة
        "النهضة للخدمات" المدرجة في بورصة مسقط.
      </p>
      <p>
        السيد مانوج هو خريج كلية سلون للإدارة التابعة لمعهد ماساتشوستس
        للتكنولوجيا في الولايات المتحدة الأمريكية، والمعاهد الهندية للإدارة، كما
        إنه زميل معتمد من قبل معهد تشارترد للأفراد والتنمية. كما يتمتع السيد
        مانوج بحضور مميز في العديد من المنتديات المهنية مثل الرابطة الدولية
        لمقاولي الحفر، وجمعية مهندسي البترول، ومعهد تشارترد للأفراد والتنمية.
      </p>`
    },
    cito: {
        bioName: "وسام العدني",
        bioPos: "الرئيس التنفيذي لتكنولوجيا المعلومات",
        bioDesc: `<p>
        انضم وسام حامد مرسي ابراهيم العدني إلى مجموعة أديس في فبراير 2022م،
        ليشغل منصب الرئيس التنفيذي لتكنولوجيا المعلومات، ليشارك خبرته التي تمتدّ
        لأكثر من 27 عاماً في مجال التحول الرقمي داخل الشركات متعدّدة الجنسيات،
        بعد أن أمضى أكثر من 4 سنوات في قيادة جهود التحول الرقمي داخل تلك
        المنظمات في البرازيل وكازاخستان.
      </p>
      <p>
        وقبل انضمامه إلى أديس، شغل السيد وسام منصب المدير التنفيذي الإقليمي
        لتكنولوجيا المعلومات في الأمم المتحدة في كلّ من منطقة أوروبا الشرقية،
        وآسيا الوسطى، ومنطقة الشرق الأوسط وشمال أفريقيا، إضافةً إلى عمله في كل
        من شركة "لافارج" الرائدة في صناعة مواد البناء، و"جي بي أوتو"، الرائدة في
        قطاع صناعة المركبات الآلية.
      </p>
      <p>
        وتقديراً لمساهماته المثمرة، حاز السيد وسام على عدّة جوائز، كجائزة "أفضل
        رئيس تنفيذي لتكنولوجيا المعلومات في الشرق الأوسط وأفريقيا لعامي 2021م
        و2022م"، وجائزة "أفضل مدير تنفيذي لتكنولوجيا المعلومات في قطاع صناعة
        المركبات الآلية" من قبل المنتدى العالمي لمديري تكنولوجيا المعلومات،
        وجائزة "أفضل رئيس تنفيذي لتكنولوجيا المعلومات خلال العام" لعامي 2020م
        و2021م على التوالي، إضافةً إلى تصنيفه من بين "أفضل 20 رئيساً تنفيذياً
        لتكنولوجيا المعلومات" في عام 2023م. ويحمل السيد وسام شهادة الماجستير في
        إدارة الأعمال من الجامعة الأمريكية في القاهرة، وشهادة البكالوريوس في
        هندسة الاتصالات والإلكترونيات.
      </p>`
    },
    dscm: {
        bioName: "عمار عباس",
        bioPos: "نائب رئيس إدارة سلسلة الإمدادات",
        bioDesc: `<p>
        انضم عمار عباس إلى مجموعة أديس مؤخراً بمنصب نائب رئيس إدارة سلسلة
        الإمدادات بعد مسيرة مهنية طويلة تمتد لحوالي 25 عاماً.
      </p>
      <p>
        يمتلك عمار خبرة واسعة في قطاع المشتريات والتوريد الاستراتيجي والخدمات
        اللوجستية والجمركية وإدارة المواد والمخزون والتتبع الدولي وتخطيط
        المنتجات وتخطيط المبيعات والعمليات. وتمتد خبرته الشاملة في قطاع سلاسل
        الإمدادات إلى حقول النفط، بما في ذلك الجوانب التقنية والجغرافية. تولى
        عمار خلال مسيرته المهنية العديد من المناصب القيادية في قطاع سلاسل
        الإمدادات في عدة مناطق استراتيجية، مثل منطقة الشرق الأوسط وأفريقيا
        وقارات أوروبا وأفريقيا وأمريكا الشمالية، حيث قدم مساهمات مهمة خلال فترة
        عمله في شركة شلمبرجير المحدودة، كما شغل العديد من المناصب القيادية
        والتنفيذية في قسم سلاسل الإمدادات في شركة خدمات الطاقة الوطنية المتحدة
        (نسر).
      </p>
      <p>
        يحمل عمار عباس شهادة البكالوريوس في الاقتصاد والعلوم المالية وإدارة
        الأعمال من جامعة حلب في سوريا، ويلتزم بأعلى معايير التميز الأكاديمي، حيث
        يتجلى ذلك في سعيه الدائم للحصول على أعلى الشهادات التدريبية في مجال
        سلاسل الإمدادات من أفضل المؤسسات التعليمية في أوروبا والولايات المتحدة،
        بما في ذلك شهادة البرنامج التنفيذي في الإدارة الاستراتيجية لسلاسل
        الإمدادات من معهد ماساتشوستس للتكنولوجيا.
      </p>`
    },
};



window.openModalLeaders=function openModalLeaders(bioId) {
    const modal = document.getElementById('dynamicModal');
    //const modalContent = document.getElementById('modalContent');
    const bioNames = document.getElementById('bioNames');
    const bioPos = document.getElementById('bioPos');
    const bioDesc = document.getElementById('bioDesc');
    
    // if (modalContents[modalId]) {
    //     const content = modalContents[modalId];
    //     document.getElementById('modalTitle').textContent = content.title;
    //     modalContent.innerHTML = content.content;
    //     modal.showModal();
    // }

    if (bioContents[bioId]) {
        const content = bioContents[bioId];
        // document.getElementById('modalTitle').textContent = content.bioName;
        bioNames.textContent = content.bioName;
        bioPos.textContent = content.bioPos;
        bioDesc.innerHTML = content.bioDesc;
        modal.showModal();
        // Prevent scrolling
        //document.body.style.scrollBehavior = 'none';
        }
}

function closeModalModalLeaders() {
    const modal = document.getElementById('modal');
    modal.close();
     // Restore scrolling
     //document.body.style.scrollBehavior = 'auto';

    }